import * as React from "react";
import { Route, Switch, Redirect } from "react-router";
import { Layout } from "./views/Layout";
import { RioAdmin } from "./views/RioAdmin";
import { Campaigns } from "./views/Campaigns";
import { IContextApiModel } from "./apiModels/IContextApiModel";
import { GlobalContext } from "./context";
import { RioIf, IRioResources, RioApiGet, setRioResources, ApiErrorHandler } from "rio.react.all";
import { ErrorModal } from "./modals/ErrorModal";
import { HttpErrorHelper } from "./helpers/HttpErrorHelper";
import { AccountStatements } from "./views/AccountStatements";
import { Dashboard } from "./views/Dashboard";
import { Users } from "./views/Users";
import { AccountStatementsSend } from "./views/AccountStatementsSend";
import { LandingWineTemplates } from "./views/LandingWineTemplates";
import { LandingWinesManualSend } from "./views/LandingWinesManualSend";
import { LandingWineEmailHistory } from "./views/LandingWineEmailHistory";
import { WarehouseClosures } from "./views/WarehouseClosures";
import { TestView } from "./views/testView";


interface IAppState {
    resourcesLoaded: boolean;
    globals: IContextApiModel;
    responseError: string;
}

export default class App extends React.Component<{}, IAppState> {
    constructor(props: {}) {
        super(props);

        ApiErrorHandler.onUnauthorised = () => {
            window.location.href = "/Login";
        };

        this.state = {
            resourcesLoaded: false,
            globals: null,
            responseError: null
        };
    }

    componentDidMount(): void {

        RioApiGet.asPromise<IContextApiModel>("/api/context/global")
            .then(response => {
                this.setState({ globals: response });
            })
            .catch(response => {
                var error = HttpErrorHelper.handleHttpError(response, this, null); //handles validator errors if validator passed
                this.setState({ responseError: error });
            });


        RioApiGet.asPromise<IRioResources>("/api/context/resources")
            .then(response => {
                setRioResources(response);
                this.setState({ resourcesLoaded: true });
            })
            .catch(response => {
                var error = HttpErrorHelper.handleHttpError(response, this, null); //handles validator errors if validator passed
                this.setState({ responseError: error });
            });

    }

    render() {
        if (!this.state.resourcesLoaded || this.state.globals == undefined) return null;

        return (
            <GlobalContext.Provider value={this.state.globals}>
                <Layout>
                    <Switch>
                        <Route exact path="/dashboard" component={Dashboard} />
						<Route path="/campaigns" component={Campaigns} />
						<Route exact path="/LandingWineTemplates" component={LandingWineTemplates} />
						<Route path="/LandingWinesManualSend/" component={LandingWinesManualSend} />
						<Route exact path="/LandingWineEmailHistory" component={LandingWineEmailHistory} />
						<Route exact path="/AccountStatementTemplate" component={AccountStatements} />
                        <Route exact path="/SendAccountStatements" component={AccountStatementsSend} />
                        <Route path="/WarehouseClosures" component={WarehouseClosures} />
						<Route exact path="/RioAdmin" component={RioAdmin} />
						<Route exact path="/Users" component={Users} />
                        <Route component={Dashboard} />
                    </Switch>
                </Layout>
                <RioIf condition={!!this.state.responseError} then={
                    <ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
                } />
            </GlobalContext.Provider>
        );
    }
}
